import { render, staticRenderFns } from "./showReview.vue?vue&type=template&id=f02f2cb2&scoped=true"
import script from "./showReview.vue?vue&type=script&lang=js"
export * from "./showReview.vue?vue&type=script&lang=js"
import style0 from "./showReview.vue?vue&type=style&index=0&id=f02f2cb2&prod&scoped=true&lang=css"
import style1 from "./showReview.vue?vue&type=style&index=1&id=f02f2cb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02f2cb2",
  null
  
)

export default component.exports